import React from 'react';
import { StyledNotificationSide } from './style';
export const NotificationSide = ({ message }: { message: string }) => {
  return (
    <StyledNotificationSide>
      <p>{message}</p>
    </StyledNotificationSide>
  );
};
